import { combineReducers } from "redux";
import userReducer from "./user/userSlice";
import mobileReducer from "./mobile/mobileSlice";

export const rootReducer = combineReducers({
  user: userReducer,
  mobile: mobileReducer,
});
